// iter 178u: i18n setup for the app-wide EN/ZH language toggle. Uses
// browser-language detection with a localStorage override so the user's
// picked language sticks across sessions. Translation JSONs live under
// ./locales — deep keys are namespaced by area (nav.*, common.*, dashboard.*,
// login.*, cart.*, etc.) for readability.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import zh from "./locales/zh.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
    },
    fallbackLng: "en",
    // Public share / customer quote pages are excluded from i18n by design
    // (buyers see English only), so any string used only there stays raw
    // in JSX and isn't looked up here.
    supportedLngs: ["en", "zh"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "app_lang",
    },
    load: "languageOnly",
    returnEmptyString: false,
  });

// iter 178z: sync the <html lang="..."> attribute with i18next's current
// language so our zh-specific font stack (:lang(zh) CSS selector) actually
// activates. Fires on init + on every language change.
const syncHtmlLang = () => {
  const resolved = i18n.resolvedLanguage || i18n.language || "en";
  const lang = resolved.startsWith("zh") ? "zh" : "en";
  if (typeof document !== "undefined") {
    document.documentElement.lang = lang;
  }
};
i18n.on("initialized", syncHtmlLang);
i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang();

export default i18n;
